(function () {
  var OPEN = 'alshaya-bundle-open';
  var BUNDLE = '.classic-bundle-swatch-circle, [class*="classic-bundle"], .usd-bundle-products-vertical';
  var MENU = '.zy-select-items, [class*="Select__ZySelectItemsWrapper"]';
  var TRIGGER = '.ushopaid-custom-selector, .zy-current-item';
  var PDP_PICKER = 'variant-picker, .product-info__variant-picker, .variant-picker, sticky-atc-variant, .sticky-atc-variant-select';
  var pdpState = null;
  var guardingPdp = false;
  var lockedScrollY = 0;
  var guardTimer = null;

  function toEl(node) {
    return node && node.nodeType === 3 ? node.parentElement : node;
  }

  function inBundle(node) {
    node = toEl(node);
    return !!(node && node.closest && node.closest(BUNDLE));
  }

  function inPdpPicker(node) {
    node = toEl(node);
    return !!(node && node.closest && node.closest(PDP_PICKER));
  }

  function findTrigger(node) {
    node = toEl(node);
    if (!node || !node.closest) return null;
    var trigger = node.closest(TRIGGER);
    if (trigger && trigger.closest('.zy-select-item')) return null;
    return trigger;
  }

  function findMenu(trigger) {
    if (!trigger) return null;
    var next = trigger.nextElementSibling;
    if (next && next.matches && next.matches(MENU)) return next;
    var parent = trigger.parentElement;
    return parent ? parent.querySelector(MENU) : null;
  }

  function capturePdp() {
    var form = document.querySelector('form[id^="product-form-"]') || document.querySelector('.product-info form');
    var idInput = form && form.querySelector('[name="id"]');
    return {
      id: idInput ? String(idInput.value || '') : '',
      url: location.pathname + location.search,
      radios: Array.prototype.slice.call(document.querySelectorAll('.product-info input[type="radio"]:checked, variant-picker input[type="radio"]:checked')),
      selects: Array.prototype.map.call(document.querySelectorAll('.product-info select, .sticky-atc-variant-select, variant-picker select'), function (el) {
        return { el: el, value: el.value };
      })
    };
  }

  function rememberPdp() {
    if (guardingPdp) return;
    pdpState = capturePdp();
  }

  function restorePdp() {
    if (!pdpState) return;
    var form = document.querySelector('form[id^="product-form-"]') || document.querySelector('.product-info form');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && pdpState.id && idInput.value !== pdpState.id) {
      idInput.value = pdpState.id;
    }
    pdpState.radios.forEach(function (el) {
      if (el && document.contains(el) && !el.checked) el.checked = true;
    });
    pdpState.selects.forEach(function (item) {
      if (item.el && document.contains(item.el) && item.el.value !== item.value) {
        item.el.value = item.value;
      }
    });
    if (pdpState.url && location.pathname + location.search !== pdpState.url) {
      history.replaceState(history.state, '', pdpState.url);
    }
    if (Math.abs((window.scrollY || window.pageYOffset) - lockedScrollY) > 1) {
      window.scrollTo(0, lockedScrollY);
    }
  }

  function startPdpGuard() {
    rememberPdp();
    guardingPdp = true;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    if (guardTimer) clearTimeout(guardTimer);
    restorePdp();
    [0, 30, 80, 160, 320, 600].forEach(function (ms) {
      setTimeout(restorePdp, ms);
    });
    guardTimer = setTimeout(function () {
      guardingPdp = false;
      guardTimer = null;
    }, 800);
  }

  var nativeFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (options) {
    if (guardingPdp && this.closest && this.closest(PDP_PICKER)) {
      return nativeFocus.call(this, Object.assign({}, options || {}, { preventScroll: true }));
    }
    return nativeFocus.apply(this, arguments);
  };

  var nativeScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (guardingPdp && this.closest && (this.closest(PDP_PICKER) || this.closest('.product-info'))) {
      return;
    }
    return nativeScrollIntoView.apply(this, arguments);
  };

  window.addEventListener(
    'scroll',
    function () {
      if (!guardingPdp) return;
      if (Math.abs((window.scrollY || window.pageYOffset) - lockedScrollY) > 1) {
        window.scrollTo(0, lockedScrollY);
      }
    },
    true
  );

  document.addEventListener(
    'focus',
    function (event) {
      if (!guardingPdp) return;
      if (inPdpPicker(event.target)) {
        event.target.blur();
        window.scrollTo(0, lockedScrollY);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (!guardingPdp) return;
      if (inPdpPicker(event.target) || (event.target && event.target.name === 'id' && !inBundle(event.target))) {
        event.stopImmediatePropagation();
        restorePdp();
      }
    },
    true
  );

  document.addEventListener(
    'variant:change',
    function (event) {
      if (guardingPdp) {
        event.stopImmediatePropagation();
        restorePdp();
        return;
      }
      rememberPdp();
    },
    true
  );

  document.addEventListener(
    'product:rerender',
    function (event) {
      if (guardingPdp) {
        event.stopImmediatePropagation();
        restorePdp();
      }
    },
    true
  );

  function closeAll() {
    document.querySelectorAll('.' + OPEN).forEach(function (menu) {
      menu.classList.remove(OPEN);
    });
    document.querySelectorAll('[data-alshaya-elevated]').forEach(function (node) {
      node.style.removeProperty('z-index');
      node.removeAttribute('data-alshaya-elevated');
    });
  }

  function elevate(menu) {
    var card = menu.closest('.usd-bundle-product-item-wrapper, .usd-bundle-product-item-vertical');
    if (card) {
      card.style.setProperty('z-index', '80', 'important');
      card.setAttribute('data-alshaya-elevated', 'true');
    }
  }

  function pinMenu(menu, trigger) {
    trigger = trigger || menu.previousElementSibling;
    if (!trigger) return;
    elevate(menu);

    var rect = trigger.getBoundingClientRect();
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var gap = 6;
    var pad = 8;
    var height = menu.offsetHeight || menu.scrollHeight || 168;
    var button = document.querySelector('.usd-bundle-submit-btn');
    var floor = button ? button.getBoundingClientRect().top - pad : window.innerHeight - pad;
    var top = Math.round(rect.bottom + gap);
    if (top + height > floor) top = Math.round(rect.top - height - gap);
    if (top < pad) top = pad;

    menu.style.position = 'fixed';
    menu.style.top = top + 'px';
    menu.style.bottom = 'auto';
    menu.style.zIndex = '2147483000';
    menu.style.pointerEvents = 'auto';
    if (rtl) {
      menu.style.right = Math.round(window.innerWidth - rect.right) + 'px';
      menu.style.left = 'auto';
    } else {
      menu.style.left = Math.round(rect.left) + 'px';
      menu.style.right = 'auto';
    }
  }

  function openMenu(menu, trigger) {
    menu.classList.add(OPEN);
    pinMenu(menu, trigger);
    requestAnimationFrame(function () {
      pinMenu(menu, trigger);
    });
  }

  rememberPdp();

  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = toEl(event.target);
      if (target && target.closest && target.closest('.zy-select-item') && inBundle(target)) {
        startPdpGuard();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = toEl(event.target);
      if (!target || !target.closest) return;

      if (guardingPdp && inPdpPicker(target) && !inBundle(target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        restorePdp();
        return;
      }

      if (target.closest('.zy-select-item') && inBundle(target)) {
        startPdpGuard();
        setTimeout(closeAll, 280);
        return;
      }

      var trigger = findTrigger(target);
      if (trigger && inBundle(trigger)) {
        var menu = findMenu(trigger);
        if (!menu) return;
        event.preventDefault();
        event.stopPropagation();
        var alreadyOpen = menu.classList.contains(OPEN);
        closeAll();
        if (!alreadyOpen) openMenu(menu, trigger);
        return;
      }

      if (!target.closest(MENU)) closeAll();
    },
    true
  );

  window.addEventListener('resize', function () {
    document.querySelectorAll('.' + OPEN).forEach(function (menu) {
      pinMenu(menu);
    });
  });

  function currencyLabel() {
    var fromHtml = document.documentElement.getAttribute('data-alshaya-currency');
    if (fromHtml) return fromHtml;
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('ar') === 0 ? 'د.ك.' : 'K.D.';
  }

  function decorateMoney(el) {
    if (!el) return;
    var extras = el.querySelectorAll('.alshaya-currency');
    for (var i = 1; i < extras.length; i++) extras[i].remove();
    if (el.querySelector('.alshaya-currency')) return;
    var money = el.classList.contains('money') ? el : el.querySelector('.money') || el;
    var raw = (money.textContent || '').replace(/\s+/g, ' ').trim();
    if (!raw) return;
    if (/د\.ك|K\.D|KWD|د\.ب|ر\.ع|ر\.س|د\.إ/i.test(raw)) return;
    var mark = document.createElement('span');
    mark.className = 'alshaya-currency';
    mark.textContent = ' ' + currencyLabel();
    money.appendChild(mark);
  }

  function parsePrice(text) {
    var n = parseFloat(String(text || '').replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function formatPrice(n) {
    return n.toFixed(2) + ' ' + currencyLabel();
  }

  function updateAtcPrices() {
    var btn = document.querySelector('.usd-bundle-submit-btn');
    if (!btn) return;

    var sale = 0;
    var compare = 0;
    var hasCompare = false;
    document.querySelectorAll('.usd-bundle-product-item-vertical').forEach(function (card) {
      var priceEl = card.querySelector('.ush-bpi-price');
      var compareEl = card.querySelector('.ush-bpi-compare-price');
      var priceVal = priceEl ? parsePrice(priceEl.textContent) : 0;
      sale += priceVal;
      if (compareEl) {
        var compareVal = parsePrice(compareEl.textContent);
        if (compareVal > 0) {
          compare += compareVal;
          hasCompare = true;
          return;
        }
      }
      compare += priceVal;
    });

    if (sale <= 0) return;

    btn.querySelectorAll('.money').forEach(function (el) {
      if (el.closest('.alshaya-bundle-atc-prices')) return;
      var prev = el.previousSibling;
      if (prev && prev.nodeType === 3) {
        prev.textContent = prev.textContent.replace(/\s*·\s*$/, ' ');
      }
      el.style.display = 'none';
    });

    var wrap = btn.querySelector('.alshaya-bundle-atc-prices');
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.className = 'alshaya-bundle-atc-prices';
      btn.appendChild(wrap);
    }

    var saleText = formatPrice(sale);
    var compareText = hasCompare && compare > sale + 0.001 ? formatPrice(compare) : '';
    var next = saleText + (compareText ? '|' + compareText : '');
    if (wrap.getAttribute('data-alshaya-atc') === next) return;
    wrap.setAttribute('data-alshaya-atc', next);
    wrap.textContent = '';

    var saleSpan = document.createElement('span');
    saleSpan.className = 'alshaya-bundle-atc-sale';
    saleSpan.textContent = saleText;
    wrap.appendChild(saleSpan);

    if (compareText) {
      var compareSpan = document.createElement('span');
      compareSpan.className = 'alshaya-bundle-atc-compare';
      compareSpan.textContent = compareText;
      wrap.appendChild(compareSpan);
    }
  }

  function applyBundleCurrency() {
    document.querySelectorAll('.ush-bpi-price, .ush-bpi-compare-price').forEach(decorateMoney);
    updateAtcPrices();
  }

  applyBundleCurrency();
  setTimeout(applyBundleCurrency, 300);
  setTimeout(applyBundleCurrency, 1000);
  var currencyObserver = new MutationObserver(applyBundleCurrency);
  currencyObserver.observe(document.body, { childList: true, subtree: true });
})();
